var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBookMark = function SvgIconBookMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .667h8v10L4 9.332l-4 1.333v-10Z",
    fill: "#4F52C3"
  })));
};
export default SvgIconBookMark;